import { MentorAreaConfig } from '../types/mentorship';

export const MOCK_MENTORSHIPS: Record<string, MentorAreaConfig> = {
  'vitor-terra': {
    id: 'm-vitor-terra',
    slug: 'vitor-terra',
    mentorName: 'Vitor Terra',
    mentorTitle: 'Engenheiro de Software & Founder',
    mentorAvatarUrl: 'https://meqeeisqsfqtplyqqxhv.supabase.co/storage/v1/object/public/mentorias/1788524785363_vytsnw.webp',
    courseTitle: 'Ventture Academy',
    tagline: 'SUA JORNADA COMEÇA AQUI',
    heroSpoiler: {
      title: 'SUA JORNADA COMEÇA AQUI',
      description: 'Bem-vindo à Ventture Academy. Entenda como nossa comunidade e mentoria vão transformar sua carreira e produtos com IA avançada.',
      youtubeUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // Link do YouTube editável
      durationText: '03 min',
    },
    branding: {
      primaryColor: '#121316',
      accentColor: '#0FFF55',
      coverImageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&q=80&w=1200',
      bannerBadge: '1.00',
    },
    bioConfig: {
      isEnabled: true,
      slug: 'vitor-terra',
      bioTitle: 'Vitor Terra',
      bioSubtitle: 'Engenheiro de Software & Founder @ Ventture Academy',
      bioAvatarUrl: 'https://meqeeisqsfqtplyqqxhv.supabase.co/storage/v1/object/public/mentorias/1788524785363_vytsnw.webp',
      socials: {
        instagram: 'https://instagram.com/vitorterra',
        youtube: 'https://youtube.com',
        whatsapp: 'https://wa.me/5511999999999',
        linkedin: 'https://linkedin.com',
        website: 'https://usezenix.com',
      },
      links: [
        {
          id: 'link-1',
          title: '⚡ Mentoria Ventture Academy VIP',
          subtitle: 'Acesse o programa completo de Engenharia de IA & Agentes',
          url: '/mentoria-vitor-terra',
          icon: 'Zap',
          isFeatured: true,
          badgeText: '🔥 MAIS POPULAR',
        },
        {
          id: 'link-2',
          title: '💬 Falar no WhatsApp Oficial',
          subtitle: 'Tire suas dúvidas diretamente com nossa equipe',
          url: 'https://wa.me/5511999999999',
          icon: 'MessageSquare',
        },
        {
          id: 'link-3',
          title: '🌐 Plataforma MasterClub VIP',
          subtitle: 'Entre na nossa comunidade exclusiva de tecnologia',
          url: '/',
          icon: 'Globe',
        },
        {
          id: 'link-4',
          title: '📺 Canal no YouTube com Aulas Gratuitas',
          subtitle: 'Vídeos semanais sobre desenvolvimento e automações',
          url: 'https://youtube.com',
          icon: 'Video',
        },
      ],
    },
    modules: [
      {
        id: 'mod-1',
        order: 1,
        title: 'INICIE SUA JORNADA AQUI',
        description: 'Fundamentos essenciais e introdução à metodologia Masterclub.',
        coverImageUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#0FFF55',
        lessons: [
          {
            id: 'les-1-1',
            order: 1,
            title: 'SUA JORNADA COMEÇA AQUI',
            durationText: '03 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 27 de jun. de 2026',
            description: 'Nesta primeira aula introdutória, entenda o mapa mental completo da mentoria e como extrair o máximo do ecossistema Masterclub.',
            isCompleted: true,
          },
          {
            id: 'les-1-2',
            order: 2,
            title: 'INDO DIRETO AO PONTO',
            durationText: '02 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 27 de jun. de 2026',
            description: 'Alinhamento de expectativas, boas vindas e diretrizes de execução.',
            isCompleted: false,
          },
          {
            id: 'les-1-3',
            order: 3,
            title: 'POR ONDE COMEÇAR',
            durationText: '06 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 28 de jun. de 2026',
            description: 'Configuração do seu ambiente de estudos e acesso às ferramentas exclusivas.',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-2',
        order: 2,
        title: 'ENGENHARIA DE PROMPT',
        description: 'Domine a arte de criar prompts estruturados de alta fidelidade para modelos de IA.',
        coverImageUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#3b82f6',
        lessons: [
          {
            id: 'les-2-1',
            order: 1,
            title: 'Fundamentos de Prompting e Contexto',
            durationText: '12 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 01 de jul. de 2026',
            description: 'Entenda os princípios matemáticos e de atenção por trás das LLMs.',
            isCompleted: false,
          },
          {
            id: 'les-2-2',
            order: 2,
            title: 'Técnicas Avançadas: Few-Shot & Chain-of-Thought',
            durationText: '18 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 02 de jul. de 2026',
            description: 'Como raciocinar em passos complexos e evitar alucinações de modelos de código.',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-3',
        order: 3,
        title: 'DESIGN DE BANCO DE DADOS',
        description: 'Estruturação de tabelas, relacioamentos e otimização para Supabase e PostgreSQL.',
        coverImageUrl: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#eab308',
        lessons: [
          {
            id: 'les-3-1',
            order: 1,
            title: 'Modelagem Relacional no PostgreSQL',
            durationText: '15 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 05 de jul. de 2026',
            description: 'Chaves estrangeiras, índices e Row Level Security (RLS).',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-4',
        order: 4,
        title: 'ARQUITETURA DE SOFTWARE E CLAUDE CODE',
        description: 'Desenvolvimento autônomo com agentes avançados de código.',
        coverImageUrl: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#0FFF55',
        lessons: [
          {
            id: 'les-4-1',
            order: 1,
            title: 'Integrando Agentes na Esteira de Software',
            durationText: '22 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 10 de jul. de 2026',
            description: 'Construção de aplicações escaláveis utilizando CLI e ferramentas de agente.',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-5',
        order: 5,
        title: 'ESTRUTURA COMERCIAL E VENDAS',
        description: 'Estratégias de aquisição, fechamento de contratos de mentoria e vendas high-ticket.',
        coverImageUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#ec4899',
        lessons: [
          {
            id: 'les-5-1',
            order: 1,
            title: 'Estruturação de Funil de Vendas de Alta Conversão',
            durationText: '16 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 15 de jul. de 2026',
            description: 'Scripts de vendas e reuniões com leads altamente qualificados.',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-6',
        order: 6,
        title: 'N8N E AUTOMAÇÃO DE PROCESSOS',
        description: 'Construção de fluxos inteligentes com n8n, webhooks e integrações de IA.',
        coverImageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#8b5cf6',
        lessons: [
          {
            id: 'les-6-1',
            order: 1,
            title: 'Primeiros Passos no n8n Self-Hosted',
            durationText: '14 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 20 de jul. de 2026',
            description: 'Instalação, criação de nodes e consumo de APIs REST.',
            isCompleted: false,
          },
        ],
      },
      {
        id: 'mod-7',
        order: 7,
        title: 'CASES DE SUCESSO',
        description: 'Estudos de caso reais de mentorados que atingiram resultados impressionantes.',
        coverImageUrl: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#10b981',
        lessons: [
          {
            id: 'les-7-1',
            order: 1,
            title: 'Estudo de Caso: De R$0 a R$50k com Agentes de IA',
            durationText: '30 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 25 de jul. de 2026',
            description: 'Passo a passo detalhado de estratégia, execução e escala.',
            isCompleted: false,
          },
        ],
      },
    ],
  },
  'lucas-almeida': {
    id: 'm-lucas-almeida',
    slug: 'lucas-almeida',
    mentorName: 'Lucas Almeida',
    mentorTitle: 'Master Coach & Estrategista Digital',
    mentorAvatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=400',
    courseTitle: 'Mentoria High Performance 10x',
    tagline: 'ALCANCE SEU POTENCIAL MÁXIMO',
    heroSpoiler: {
      title: 'DESPERTE SUA PERFORMANCE 10X',
      description: 'Descubra a metodologia de alta performance que transformou mais de 1.000 executivos e mentores.',
      youtubeUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      durationText: '04 min',
    },
    branding: {
      primaryColor: '#121316',
      accentColor: '#eab308',
      coverImageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=1200',
      bannerBadge: 'VIP 2.0',
    },
    modules: [
      {
        id: 'mod-l1',
        order: 1,
        title: 'MINDSET DE ALTA PERFORMANCE',
        description: 'Reprogramação de crenças, foco inabalável e disciplina diária.',
        coverImageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=600',
        accentGlowColor: '#eab308',
        lessons: [
          {
            id: 'les-l1-1',
            order: 1,
            title: 'Os 5 Pilares da Alta Performance',
            durationText: '10 min',
            videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
            thumbnailUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=600',
            publishedAtText: 'Publicado em 01 de ago. de 2026',
            description: 'Como construir uma rotina blindada contra distrações.',
            isCompleted: false,
          },
        ],
      },
    ],
  },
};

export const getMentorshipBySlug = (slug: string): MentorAreaConfig => {
  // Limpar a slug caso venha com prefixos comuns
  const cleanSlug = slug.replace(/^\/?(mentoria-|bio-|links-|bio\/)?/, '').toLowerCase();
  
  if (MOCK_MENTORSHIPS[cleanSlug]) {
    return MOCK_MENTORSHIPS[cleanSlug];
  }

  // Se a slug for vazia ou 'vitor-terra', retorna o mock oficial
  if (!cleanSlug || cleanSlug === 'vitor-terra') {
    return MOCK_MENTORSHIPS['vitor-terra'];
  }

  // Fallback neutro dinâmico baseado na slug informada (nunca herdando dados de Vitor Terra)
  const formattedName = cleanSlug
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  const defaultMentor = MOCK_MENTORSHIPS['vitor-terra'];
  return {
    ...defaultMentor,
    id: `m-${cleanSlug}`,
    slug: cleanSlug,
    mentorName: formattedName,
    mentorTitle: 'Mentor Oficial',
    mentorAvatarUrl: '',
    courseTitle: `Mentoria ${formattedName}`,
    tagline: 'SUA JORNADA COMEÇA AQUI',
    bioConfig: {
      isEnabled: true,
      slug: cleanSlug,
      bioTitle: formattedName,
      bioSubtitle: 'Mentor Oficial @ MasterClub VIP',
      bioAvatarUrl: '',
      socials: {
        instagram: '',
        youtube: '',
        whatsapp: '',
        linkedin: '',
        website: '',
      },
      links: [
        {
          id: 'link-1',
          title: `⚡ Mentoria VIP - ${formattedName}`,
          subtitle: 'Acesse o programa oficial de mentoria e acompanhamento',
          url: `/mentoria-${cleanSlug}`,
          icon: 'Zap',
          isFeatured: true,
          badgeText: '🔥 OFICIAL',
        },
        {
          id: 'link-2',
          title: '🌐 Plataforma MasterClub VIP',
          subtitle: 'Acesse nossa comunidade exclusiva de tecnologia e networking',
          url: '/',
          icon: 'Globe',
        },
      ],
      theme: {
        accentColor: '#0FFF55',
        backgroundColor: '#0d0e11',
      },
    },
  };
};
